'use client';

import React, { useRef, useState, useEffect } from 'react';
import { SwiperSlide } from 'swiper/react';
import ProductCardWithSlider from '@/app/components/Card/ProductCardWithSlider';
import Icon from '@/app/components/Icon';
import { TITAN_WHITE } from '@/constants';
import { cn } from '@/utils/cn';
import { contentsAPIV2 } from '@/utils/contentsApi';
import { sliderMainClassTypes, sliderNavigationTypes } from '@/constants/types';
import SliderWrapper from '../Wrapper/SliderWrapper';

// swiper slider
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function HomepageThreeProductCarousel({ section }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [data, setData] = useState([]);
  const [arrowPrevColor, setArrowPrevColor] = useState('#49525E');
  const [arrowNextColor, setArrowNextColor] = useState('#49525E');
  const [isScreenSmall, setIsScreenSmall] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPIV2(contentsData);
        setData([...response.items]);
      } catch (err) {
        console.warn('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setIsScreenSmall(window.innerWidth < 1440);
      };
      handleResize();

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <SliderWrapper
      outerDivClass={cn(
        'three-product-slider h-auto mt-24 mb-[24px] lg:mt-[40px] lg:mb-[40px] relative !flex !justify-center',
        {
          'container max-w-[1440px] mx-auto': !isScreenSmall,
        },
      )}
      containerRefClass="container 3xl:max-w-[1440px] mx-auto hidden"
      sliderMainClassType={sliderMainClassTypes.threeProduct}
      sliderNavigationType={sliderNavigationTypes.withNavigation}
      prevButtonRef={prevRef}
      nextButtonRef={nextRef}
      onlyForThreeProductSlider
    >
      {data?.slice(0, 3)?.map((item, index) => (
        <SwiperSlide key={item?.id ?? index} className="!w-max">
          <ProductCardWithSlider item={item} />
        </SwiperSlide>
      ))}
      {/* navigation button */}
      <div
        ref={prevRef}
        className="swiper-button-prev !flex justify-center items-center !w-[36px] !h-[36px] bg-titanwhite rounded-full shadow-product-slider-shadow"
        onMouseEnter={() => setArrowPrevColor(TITAN_WHITE)}
        onMouseLeave={() => setArrowPrevColor(TITAN_WHITE)}
      >
        <Icon
          type="angle-right2"
          color={arrowPrevColor}
          className="!w-[24px] !h-[24px] -rotate-180"
        />
      </div>

      <div
        ref={nextRef}
        className="recently-viewed-slider swiper-button-next !right-0 !flex justify-center items-center !w-[36px] !h-[36px] bg-titanwhite rounded-full shadow-product-slider-shadow"
        onMouseEnter={() => setArrowNextColor(TITAN_WHITE)}
        onMouseLeave={() => setArrowNextColor(TITAN_WHITE)}
      >
        <Icon
          type="angle-right2"
          color={arrowNextColor}
          className="!w-[24px] !h-[24px]"
        />
      </div>
    </SliderWrapper>
  );
}

export default HomepageThreeProductCarousel;
